import { ContentWrapper, Close, Backdrop, Content, Title, Subtitle, Option, OptionList, RadioCircle, RadioCircleInner, Back } from "./OccupationPicker.style";

export interface OccupationOption {
  title: string;
  occupation: string;
}

interface ProductModalProps {
  title: string;
  subtitle: string;
  options?: OccupationOption[];
  onClose?: () => void;
  onOptionSelect: (option: OccupationOption) => void;
}

export default function OccupationPicker({title, subtitle, options, onClose, onOptionSelect }: ProductModalProps) {
    const handleOptionClick = (option: OccupationOption) => {
        onOptionSelect(option);
    }

    return (
        <>
        <Backdrop onClick={onClose}>
            <Content onClick={(e) => e.stopPropagation()}>
                <Close>
                    <Back onClick={onClose} />
                </Close>
                <ContentWrapper>
                    <Title>{title}</Title>
                    <Subtitle>{subtitle}</Subtitle>
                    {options && (
                    <OptionList>
                        {options.map((option, index) => (
                            <Option key={index} onClick={() => handleOptionClick(option)}>
                                <RadioCircle>
                                    <RadioCircleInner />
                                </RadioCircle>
                                {option.title}
                            </Option>
                        ))}
                    </OptionList>
                    )}
                </ContentWrapper>
            </Content>
        </Backdrop>
    </>
    );
}